export enum CryptoAreaTypes {
    SET_DATA = "CRYPTO_AREA/SET_DATA",
}